import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function TechnicalInspectionNoteTextarea() {
  return (
    <Field
      type="textarea"
      name="technicalInspectionNote"
      minRows={3}
      label={i18n.t('entity.vehicle.labels.technicalInspectionNote')}
    />
  );
}
